import * as z from "zod/v4";

export const getContextualTimeseries = {
  name: "getContextualTimeseries" as const,
  input: z.object({
    fromDate: z.string(),
    toDate: z.string(),
    event: z.string(),
    aggregate: z.enum(["SUM", "AVG", "UNIQUE"]),
    unit: z.enum(["DAY", "WEEK", "MONTH"]),
  }),
  output: z.object({
    labels: z.array(z.string()),
    series: z.array(z.object({ name: z.string(), data: z.array(z.number()) })),
  }),
};
